import { ConnectionModel } from '@/types'
import { createContext, Context } from 'react'
import { ListingGenericContext } from './ListingGenericContext'

interface ConnectionsListContextProps extends ListingGenericContext<ConnectionModel> {}

export const ConnectionsListContext: Context<ConnectionsListContextProps> = createContext(
  {} as ConnectionsListContextProps,
)
